<template>
  <SlidingPanel
    v-if="x.relatedTags.length"
    class="x-sliding-panel-show-buttons-on-hover"
    button-class="x-button-lead x-button-circle x-button-ghost x-p-0"
    scroll-container-class="desktop:x-sliding-panel-fade"
    :show-buttons="!isTouchable"
  >
    <template #sliding-panel-left-button>
      <ChevronLeftIcon class="x-icon-lg" />
    </template>
    <RelatedTags
      class="x-gap-8 x-pl-16 tablet:x-pl-24 desktop:x-pl-0"
      :highlight-curated="true"
      :animation="relatedTagsAnimation"
      item-class="x-tag-outlined x-rounded-full x-border-neutral-25 x-text-neutral-75"
    >
      <template #related-tag-content="{ relatedTag, isSelected, shouldHighlightCurated }">
        <CuratedCheckIcon v-if="shouldHighlightCurated" />
        {{ relatedTag.tag }}
        <CrossTinyIcon v-if="isSelected" />
        <PlusIcon v-else />
      </template>
    </RelatedTags>
    <template #sliding-panel-right-button>
      <ChevronRightIcon class="x-icon-lg" />
    </template>
  </SlidingPanel>
</template>

<script setup lang="ts">
import {
  ChevronLeftIcon,
  ChevronRightIcon,
  CrossTinyIcon,
  CuratedCheckIcon,
  PlusIcon,
  SlidingPanel,
  StaggeredFadeAndSlide,
  use$x,
} from '@empathyco/x-components'
import { RelatedTags } from '@empathyco/x-components/related-tags'
import { useDevice } from '../../composables/use-device.composable'

const relatedTagsAnimation = StaggeredFadeAndSlide as any
const { isTouchable } = useDevice()
const x = use$x()
</script>

<style lang="scss">
.x-related-tags__item > .x-tag.x-selected {
  background-color: theme('colors.lead.50') !important;
  border-color: theme('colors.lead.50') !important;
  color: theme('colors.neutral.0') !important;
  font-weight: 700 !important;
}
</style>
